import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { AuthService } from 'angular-6-social-login';
import { SocialUser } from 'angular-6-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angular-6-social-login';
import { Config } from '../../config/config';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Snotify, SnotifyService } from 'ng-snotify';
import { RestDataService } from '../../service/rest-data.service';
import { MessagingService } from '../../service/messaging.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    public config: Config,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private authService: AuthService,
    private sharedService: SharedDataService,
    private fb: FormBuilder,
    private snotify:SnotifyService,
    private restService: RestDataService,
    private messageService : MessagingService
  ) {
  }

  returnUrl = this.sharedService.returnUrl || '/';;
  staySignedIn = false;
  loginFailed = false;
  user: SocialUser;

  errorMessage: string;
  isLdap:Boolean;
  loginFlag:string='';

  loginForm: FormGroup = this.fb.group({
    email: ['', Validators.required],
    idToken: ['', Validators.required]
  });

  ngOnInit() {
    this.logout();
  }

  logout() {
    this.authenticationService.logout();
    this.authService.authState.subscribe((user) => {
      if (user) {
        this.authService.signOut();
      }
    });
    this.returnUrl = this.sharedService.returnUrl || '/';
  }

  loginAuth(user,flag) {
    let loginType=flag;
    if (user) {
      this.authenticationService.login(user, true,loginType).subscribe(
        data => {
          this.sharedService.setDomain();
          this.sharedService.setConfig();
          setTimeout(()=>{
          this.restService.http_put(this.config.get('product').authenticationServiceUrl
                  +"/api/updateFcmBrowserId?fcmBrowserId="+
                  this.messageService.token,
                  user,
                  (result)=>{});},60000);
          this.router.navigate([this.returnUrl]);
        },
        error => {
          this.loginFailed = true;
          if (Math.abs(error.status / 100) === 4) {
            this.errorMessage = error.error['error_description'];
          } else {
            this.errorMessage = 'unknown error';
          }
        });
    }
  }

  signInWithGoogle() {
    this.isLdap=false;
    this.loginFlag='gmail';
    if (this.authService) {
      this.authService.signIn(GoogleLoginProvider.PROVIDER_ID)
        .then(data => {
          this.loginAuth(data,this.loginFlag);
        },
          error => {
            console.log(error);
            this.loginFailed = true;
            this.errorMessage = error.error;
            this.authService.signOut()
              .then(res => {
              })
              .catch(err => {
                console.log(err);
              });
          }).catch(err => {
            console.log(err);
          });
    } else {
      console.log('provider not working');
    }
  }

  signInWithAD() {
     this.loginFlag='ldap';
    this.errorMessage = '';
    if (this.loginForm.status && this.loginForm.status.toLowerCase() === 'valid') {
      this.loginAuth(this.loginForm.value,this.loginFlag);
    } else {
      this.errorMessage = 'Email id or Password cannot be blank.';
    }
  }
  ldapClick(){
    this.isLdap=!this.isLdap
  }
}
